<template>
  <div class="page">
    <top-header></top-header>
    <div class="cont-box">
      <b-container fluid style="margin-top:5%;">
        <b-row class="mt-3 mb-2">
          <b-col class="col-md-6 col-sm-6 col-xs-6">
            <h3 class="text-white">LED Driver Stock  <!-- <spna style="font-size: 15px;">{{timeData}}</spna> --></h3>
          </b-col>
          <b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
           <b-button
              variant="dark"
              pill
              class="mr-2"
              v-if="$root.chkperm('page_complaint', 'add')"
              @click="showAddModal()"
              >Assign Driver</b-button
            >
            
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid>
        <b-row>
          <b-col class="col-md-12 col-sm-12 col-xs-12">
            <div class="container-box">
               <b-row class="mt-4 px-3">
              <b-col>
                <!-- <b-form inline>
                  <b-form-group>                
                  <label for="inline-form-input-name" class="mr-sm-2 justify-left">From: </label>
                  <b-form-datepicker
                    v-model="datefrom"
                    class="mr-sm-2"
                    size="sm"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  ></b-form-datepicker>
                  </b-form-group>
                  <b-form-group>
                  <label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
                  <b-form-datepicker
                    v-model="dateto"
                    class="mr-sm-2"
                    size="sm"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  ></b-form-datepicker>
                  </b-form-group>                  
                  <b-button @click="datefilter()" size="sm" class="mt-4">Show</b-button>                
                </b-form> -->
              </b-col>
              <b-col class="text-right"> 
               
                <!-- <b-button variant="dark" pill size="sm" class="mr-2"  @click="downloadPDF()">Download PDF</b-button>  -->
				  <b-button variant="dark" pill size="sm"  @click="downloadcsv()">Download CSV</b-button>
				 
						 
              
              </b-col>
              </b-row>
              <b-row class="mt-4 ml-2 mr-2 px-0">
                <b-col lg="2" sm="12">
                  <span class="mr-2">Show</span>
                  <b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
                  </b-form-select>
                  <span class="ml-2">entries</span>
                </b-col>
                <b-col lg="7" sm="12" class="text-center space-between">
											<!-- <span class="mr-2">Filters</span>
											<b-form-select v-model="selectedfilter" :options="subjectoptionsFilter" size="sm" class="w-20" @change="onFilterChange()">
											</b-form-select>
											<span class="ml-2 mr-1">Status</span>
											<b-form-select v-model="networkfilter" :options="statusOptionsfilter" size="sm" class=" w-20" @change="onFilterChange()">                       
											</b-form-select> -->


                     <!--  <span class="ml-2 mr-1">Ward</span> -->
                     <!--  <VSelect v-model="wardfilter" :options="wardfilterlist" :searchable="true" defaultTitle="All Wards" size="sm" class=" w-20 custom-select custom-select-sm ml-2" @input="onFilterChangeward()">
                      </VSelect> -->
					

                       <span class="ml-2 mr-1">Department Supervisor</span>
                    <VSelect v-model="supervisorfilter" :options="supervisorfilterlist" :searchable="true" defaultTitle="All Supervisor" size="sm" class=" w-20 custom-select custom-select-sm" @input="onFilterChangesupervisor()">
                      </VSelect>
           
              
                       <!-- <b-form-select v-model="complaintypefilter"  @change="onFilterChangeComtype()" size="sm" class=" w-15">
                        <b-form-select-option value="all">Complain Type</b-form-select-option>
                        <b-form-select-option value="auto">Auto</b-form-select-option>
                        <b-form-select-option value="manual">Manual</b-form-select-option>
                      
                      </b-form-select> --> 
									
								</b-col>
              
                <b-col lg="3" sm="12">
                  <b-form-group
                    label="Filter"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
                      </b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="px-3 pt-3">
                <b-col lg="12">
                  <b-table
                    show-empty
                    sticky-header
                    responsive
                    outlined
                    caption-top
                    hover
                    head-variant="dark"
                    borderless="borderless"
                    id="my-table-live"
                    stacked="md"
                    stickyColumn="scrolled"
               
                    :items="filteredrecords"                  
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filterIncludedFields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                    class="scrollH d-flex" 
                  >

                   <!--  :items="records" -->
                   <template #cell(srno)="data">
                       {{ data.index + 1 }}
                    </template>
                 
                  <template v-slot:head(fp_no)="data">                     
                    <span :title='data.tooltip' v-b-popover.hover.top="'Feeder Piller No.'" >{{ data.label}}           
                    </span>           
                  </template>
                  <template v-slot:cell(fp_no)="row">
												<b-link :href="'/inventory/led-detail/'+row.item.fp_no">{{row.value}}</b-link>
									</template>
                  <template v-slot:cell(no_of_fittings_used)="row">											
                       <b-link :href="'/inventory/stock-used-history/'+row.item.supervisor_id"> {{ row.value }}</b-link>
									</template>
                  <template v-slot:cell(in_stock)="row">											
                       {{ row.item.no_of_fittings - row.item.no_of_fittings_used }}
									</template>
                 
                   
                    <template v-slot:cell(actions)="row">
                       <b-button
                        pill
                        variant="dark"
                        class="mr-1"
                       
                        :href="'/inventory/led-driver-history/'+row.item.supervisor_id"
                        size="sm"
                        ><b-icon icon="clock-history" font-scale="1"></b-icon
                      ></b-button>
                      <!-- <b-button
                        pill
                        variant="dark"
                        class="mr-1"
                        v-if="$root.chkperm('page_complaint', 'edit')"
                        @click="showUpdateModal(row.item, row.index, $event.target)"
                        size="sm"
                        ><b-icon icon="pencil" font-scale="1"></b-icon
                      ></b-button> -->
                      <!-- <b-button
                        pill
                        variant="danger"
                        class="mr-1"
                        v-if="$root.chkperm('page_complaint', 'delete')"
                        @click="showDeleteModal(row.item)"
                        size="sm"
                        >DELETE</b-button
                      > -->
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="px-3">
                <b-col lg="6">
                  <span class="mr-2"
                    >Showing {{ currentPage }} to {{ perPage > filteredrecords.length ? filteredrecords.length : perPage }} of
                    {{ filteredrecords.length }} entries</span
                  >
                </b-col>
                <b-col lg="3" offset-md="3">
                  <b-pagination
                    v-model="currentPage"
                    pills
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="right"
                    size="sm"
                    prev-text="Prev"
                    next-text="Next"
                    first-number
                    last-number
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <!-- ******************************************************************************************* -->
        <!-- ********************Add/ Edit Assign Light model S T A R T ***************************** -->
        <b-modal
          id="my-model"
          :title="selectedItem.id > 0 ? 'Update Led Driver' : 'Assign Led Driver'"
          ok-only
          @hidden="resetSelectedItem"
          @ok="modalSubmit"
          size="md"
        >
          <form ref="form" @submit.stop.prevent="handleSubmit">

             <!-- <b-form-group label="Feeder Pillar" label-cols="3" label-size="sm" label-align-sm="right">
              <b-form-input
                v-model="selectedItem.fp_no"
                required
                maxlength="30"
                :disabled="selectedItem.id > 0"
              ></b-form-input>
            </b-form-group>  -->
              <!-- <span class="ml-2 mr-1">Supervisor</span>
              <VSelect v-model="selectedItem.supervisor_id" :options="supervisorfilterlist" :searchable="true" defaultTitle="All Supervisor" size="sm" class=" w-120 custom-select custom-select-sm" >
              </VSelect> --> 
               <b-form-group
              label="Department Supervisor"
              label-cols="4"
              label-size="sm"
              label-align-sm="right"  
              :disabled="selectedItem.id>0"       
            >
              <b-form-select v-model="selectedItem.supervisor_id"  >
                <b-form-select-option value="0">--- Select Supervisor ---</b-form-select-option>
                <b-form-select-option v-for="item in supervisorlist" v-bind:key="item.supervisor_id" :value="item.supervisor_id">{{
                  item.username
                }}</b-form-select-option>
              </b-form-select>
            </b-form-group>

              <p>&nbsp;</p>
           <!--  <p class="text-center"><b>Feeder Pillar: {{ selectedItem.fp_no }}</b>:{{ selectedItem.location }}</p> -->
            <div class="panel-new panel-new-3">
              <!-- <h4>LED Information</h4> -->
              <b-row style="justify-content: center;" class="px-3">
                <b-col class="pl-5  tbl-header" cols="6" >
                  LED Driver
                </b-col>
                <b-col class="pr-0 tbl-header" cols="3" >
                  Warranty
                </b-col>
                <b-col class="pr-0 tbl-header" cols="3" >
                 Brand
                </b-col>
               <!--  <b-col class="pr-0 tbl-header" cols="2" >
                Vendor
                </b-col> -->
               
              </b-row>

              <b-row style="justify-content: center;" v-for="item in this.$root.wattslight" v-bind:key="item" class="px-3 py-0">
                <b-col class="pr-0" cols="6" >
                  <b-form-group :label="'LED '+item+' W'" label-cols="6" label-size="sm" label-align-sm="right">
                    <b-form-input v-model="selectedItem.led_fittings['w'+item]" type="number" ></b-form-input>  <!-- @change="updateTotalLoad" -->
                  </b-form-group>
                </b-col>
                <b-col class="pr-0" cols="3" >
                 
                  <b-form-group  >           
                  <b-form-input v-model="selectedItem.led_warranty['warranty'+item]" required maxlength="50" ></b-form-input>
                 </b-form-group>
                </b-col>
                <b-col class="pr-0" cols="3" >
                  <b-form-group  >                  
                      <b-form-select v-model="selectedItem.led_brand['brand'+item]" :options="brandOption" required></b-form-select>               
                  </b-form-group>
                </b-col>
               <!--  <b-col class="pr-0" cols="2" >
                  <b-form-group
                  
                  v-if="$root.chkperm('page_complaint', 'change_status')"
                  >
                  <b-form-select v-model="selectedItem.led_vendors['vendor'+item]" :options="vendorOption" required></b-form-select>
                  
                  </b-form-group>
                </b-col> -->
                
                

              </b-row>
            </div>
          </form>
          <template v-slot:modal-footer="{ ok, close }">
            <b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
            <b-button size="sm" variant="success" @click="ok()">{{
              selectedItem.id > 0 ? "Update" : "Submit"
            }}</b-button>
          </template>
        </b-modal>

         <!-- ********************E N D  ***************************** -->
      </b-container>
      <transition name="fade">
        <b-row
          v-if="loading"
          class="loading"
          style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);"
          align-v="center"
          align-h="center"
        >
          <b-spinner label="Busy" variant="light"></b-spinner>
        </b-row>
      </transition>
    </div>
  </div>
</template>
<script>

/* document.getElementById('my-table-live').on('hover','th',function(){

  console.log('Hover:');
}); */

/* document.getElementById("my-table-live").onmouseover = (function(){ 
  console.log('sdasdas');

}); */
       


import Header from "@/components/Header.vue";
//import VSelect from "@/vue-select-picker-bootstrap";
import VSelect from "vue-select-picker-bootstrap";
export default {
  name: "leddriver",
  components: {
    "top-header": Header,
  VSelect
    //"v-select":VSelect,
  },
  mounted() {
    var self = this;
    Object.assign(self.selectedItem, self.emptyItem);
    //console.log('wattslight:'+JSON.stringify(this.$root.wattslight));
    this.initload();
    //this.fetchLocations();
    
  },
  data() {
    var self = this;
    return {
      loading: true,
      email: "",
      password: "",
      recordUrl: self.$session.get("apiurl") + "inventoryapi/driverstock",
      insertUrl: self.$session.get("apiurl") + "inventoryapi/driverstock-insert",
      updateUrl: self.$session.get("apiurl") + "inventoryapi/driverstock-update",
     // deleteUrl: self.$session.get("apiurl") + "inventoryapi/complaint-delete",
      //locationUrl: self.$session.get("apiurl") + "inventoryapi/ulb-locations",
      supervisorUrl: self.$session.get("apiurl") + "inventoryapi/getdepSupervisor-list",
      records: [],
      filteredrecords: [],
      locations: [],
      locationfilter:'',
      locationsOption: [],
      fpfilter:'',
      fpOption: [],
      supervisorlist:[],
      supervisorfilterlist:[],
      wardfilterlist:[],
      brandOption:[],
      led_brands:[],
      vendorOption:[],
      
      statusOptions: [
        { value: 0, text: "NEW" },
        { value: 1, text: "In Progress" },
        { value: 2, text: "Closed" },
      ],
      statusOptionsfilter: [
      { value:'all', text: "All" },
        { value: 0, text: "NEW" },
        { value: 1, text: "In Progress" },
        { value: 2, text: "Closed" },
      ],
      subjectoptions: [
        { value: 0, text: "Select Subject" },
        { value: 7, text: "Signal Loss" },
        { value: 2, text: "Lights ON at day time" },
        { value: 8, text: "Lights OFF at night time" },
        { value: 3, text: "Meter Burnt" },
        { value: 4, text: "MCB Burnt" },
        { value: 5, text: "Disconnected / Network Issue" },
        { value: 6, text: "Wire Burn" },
        { value: 1, text: "Light OFF" }, 
        { value: 9, text: "Door Open" },
        { value: 10, text: "Overload" },   
        { value: 11, text: "Underload" },
        { value: 12, text: "Maintenance" }       
       
      ],
      subjectoptionsFilter: [
        { value: 0, text: "Complaint Type" },
        { value: 7, text: "Signal Loss" },
        { value: 2, text: "Lights ON at day time" },
        { value: 8, text: "Lights OFF at night time" },
        { value: 3, text: "Meter Burnt" },
        { value: 4, text: "MCB Burnt" },
        { value: 5, text: "Disconnected / Network Issue" },
        { value: 6, text: "Wire Burn" },
        { value: 1, text: "Light OFF" },
        { value: 9, text: "Door Open" },
        { value: 10, text: "Overload" },   
        { value: 11, text: "Underload" },
        { value: 12, text: "Maintenance" }        
       
      ],
      led_fittings: {},
      led_warranty:{},
      led_brand:{},
      led_vendors:{},
      
      selectedfilter:0,
      networkfilter:'all',
      supervisorfilter:'all',
      wardfilter:'all',
      complaintypefilter:'all',
      zones: [],
      wards_list:[],
      zoneOptions: [],
      fields: [
        /* { key: "id", label: "ID" }, */
        { key: 'srno', label: 'Sr. no', thStyle:'min-width:80px;', 'extra': 1  },
         { key: "supervisor_id", label: "Issued To",sortable: true, thStyle:'min-width:80px;', class:'fpno',
          formatter: (value) => {
            var self = this;
            return self.supervisorlist.filter(function(item) {
              if (item.supervisor_id == value) {
                return item;
              }
            })[0].username;
          },
         },
        { key: "no_of_fittings", label: "Quantity Issued",sortable: true},
       /*  { key: "no_of_fittings_used", label: "Quantity Used", sortable: true},  */
        { key: "in_stock", label: " Quantity in Stock",extra: 1,sortable: true}, 
        {key: "update_time",
          label: "Update Time",thStyle:'min-width:146px;',
          formatter: (value, key, item) => {
            if (item.update_time == "") {
              return "00-00-0000 00:00:00";
            }
            return this.$moment(item.update_time).format("DD-MM-YYYY HH:mm:ss");
          },
        }, 
       /*  { key: "read_status", label: "Read Status",thStyle:'min-width:100px;' }, */
       /*  { key: "actions", label: "Actions", extra: 1, class: "text-right" }, */
      ],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      selectedItem: { 
                      supervisor_id:'',
                      led_fittings:{},
                      led_warranty:{},
                      led_brand:{},
                      led_vendors:{}                    
                       },     
      emptyItem: {
        id: 0,
        supervisor_id:'',
        led_fittings:{},
        led_warranty:{},
        led_brand:{},
        led_vendors:{}
      },
      timeData:'(24 Hourse Data )',
      datefrom: '',
      dateto: '',
    };
  },
  methods: {
    filterZone: function(items) {
      var self = this;
      return items.filter(function(item) {
        if (item.parent == 0 && item.state == self.selectedItem.state) {
          return true;
        }
      });
    },
    filterULB: function(items) {
      //var self = this;
      return items.filter(function(item) {
        return item.parent > 0;
      });
      //item.parent == self.selectedItem.district &&
    },
      onFilterChange() {
    //this.records = this.filterChange(this.records);
        /* this.totalRows = this.filteredrecords.length;
      this.currentPage = 1; */

    // this.records = this.networkChange(this.filterChange(this.records));
    this.supervisorfilter = 'all';
    this.wardfilter       = 'all';
    
    this.filteredrecords = this.networkChange(this.filterChange(this.records));
    
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
    },
    onFilterChangesupervisor(){
      this.supervisorfilter =this.supervisorfilter.value;    
      this.filteredrecords = this.filtersupervisorChange(this.records);    
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;

    },  
     onFilterChangeward(){
      this.wardfilter =this.wardfilter.value;    
      this.filteredrecords = this.filterwardChange(this.records);    
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;

    }, 
    onFilterChangeComtype(){
     // this.complaintypefilter =this.complaintypefilter;    
      this.filteredrecords = this.filtercomtypeChange(this.records);    
      this.totalRows = this.filteredrecords.length;
      this.currentPage = 1;

    },  
    filterChange(devices) {
      var self = this;
      return devices.filter(function(d) {
        //console.log('-----'+self.selectedfilter);
          if (self.selectedfilter ==0) {
            return d;
          }

          if (self.selectedfilter ==1) {
            if (d.subject ==1) {
              return d;
            }
          }

          if (self.selectedfilter==2) {
            if (d.subject == 2) {
              return d;
            }
          }
          if (self.selectedfilter == 3) {
            if (d.subject == 3 ) {
              return d;
            }
          }
          if (self.selectedfilter == 4) {
            if (d.subject == 4 ) {
              return d;
            }
          }
          if (self.selectedfilter == 5) {
            if (d.subject ==5 ) {
              return d;
            }
          }
          if (self.selectedfilter == 6) {
            if (d.subject ==6 ) {
              return d;
            }
          }
          if (self.selectedfilter == 7) {
            if (d.subject ==7 ) {
              return d;
            }
          }
          if (self.selectedfilter == 8) {
            if (d.subject == 8 ) {
              return d;
            }
          }
          if (self.selectedfilter == 9) {
            if (d.subject == 9 ) {
              return d;
            }
          }
          if (self.selectedfilter == 10) {
            if (d.subject == 10 ) {
              return d;
            }
          }
          if (self.selectedfilter == 11) {
            if (d.subject == 11 ) {
              return d;
            }
          }
          if (self.selectedfilter == 12) {
            if (d.subject == 12 ) {
              return d;
            }
          }
         
          
          
      });
    },
    networkChange(devices){
			var self = this;
      //console.log('-----'+self.networkfilter);
			return devices.filter(function (d) {
				if(self.networkfilter =='all'){
					return d;
				}
				else{
          
					if(self.networkfilter == 0){
						if(d.status ==0){
							return d;
						}
					}
					else if(self.networkfilter == 1){
						if(d.status == 1){
							return d;
						}
					}else if(self.networkfilter == 2){
						if(d.status == 2){
							return d;
						}
					}
				}
			});
		},
    filtersupervisorChange(devices){
      var self = this;
     	return devices.filter(function (d) {         
				if(self.supervisorfilter =='all'){
					return d;
				}
				else{          
					if(self.supervisorfilter == d.supervisor_id){					
							return d;						
					}					
				}
			});      
    },
    filterwardChange(devices){
      var self = this;
     	return devices.filter(function (d) { 
     		if(self.wardfilter =='all'){
					return d;
				}
				else{          
					if(self.wardfilter == d.ward_id){					
							return d;						
					}					
				}
			});
    },
    filtercomtypeChange(devices){
      var self = this;
     	return devices.filter(function (d) { 
     		if(self.complaintypefilter =='all'){
					return d;
				}
				else{          
					if(self.complaintypefilter == d.complain_type){					
							return d;						
					}					
				}
			});
    },
    showAddModal() {
      var self = this;
      //alert(this.$session.get('user_info').permissions.state);
      this.selectedItem = Object.assign({}, self.emptyItem);
      /* this.selectedItem.state = this.$session.get("user_info").permissions.state_perm;
      self.zones.forEach(function(item) {
        if (String(item.areacode) === String(self.$session.get("user_info").permissions.ulb_perm)) {
          self.selectedItem.ulb = item.id;
        }
      }); */
      this.$root.$emit("bv::show::modal", "my-model");
      //this.fetchLocations();
    },
    showUpdateModal(item, index, button) {
      this.selectedItem = Object.assign({}, item);
      /* this.selectedItem.old_message =
        "---- Update Time: " + this.$moment(item.update_time).format("DD-MM-YYYY HH:mm:ss") + " ----\n" + item.message; */

        var fittings = {};
        var warranty ={};
        var brand = {}
        var vendoeListopt = {};
        var ledfitting ={};
        var ledWarranty ={};
        var ledBrand ={};
        var ledVendors ={};
       
      if(item.led_fittings!=null && item.led_fittings!=''){
        ledfitting  =JSON.parse(item.led_fittings);
      }
      if(item.led_vendor!=null && item.led_vendor!=''){
        ledVendors   = JSON.parse(item.led_vendor);
      }
      if(item.led_vendor!=null && item.led_vendor!=''){
        ledVendors   = JSON.parse(item.led_vendor);
      }
      if(item.led_warranty!=null && item.led_warranty!=''){
        ledWarranty = JSON.parse(item.led_warranty);
      }
      if(item.led_brand!=null && item.led_brand!=''){
        ledBrand    =JSON.parse(item.led_brand);  
      } 
     


       /*  var ledfitting =JSON.parse(item.led_fittings);
        var ledWarranty =JSON.parse(item.led_warranty);
        var ledBrand =JSON.parse(item.led_brand);
        var ledVendors =JSON.parse(item.led_vendor); */

        // console.log("ledfitting ",ledfitting);
        // console.log("vendoeListopt ",vendoeListopt);
        // console.log("ledVendors ",ledVendors);



        
        this.$root.wattslight.forEach(function(value){
          //console.log("value value:::::::::::::",value);
            fittings['w'+value]         = ledfitting['w'+value];
            warranty['warranty'+value]  = ledWarranty['warranty'+value]; 
            brand['brand'+value]        = ledBrand['brand'+value]; 
            vendoeListopt['vendor'+value]  = ledVendors['vendor'+value]; 
          
        });
        this.selectedItem.led_fittings= fittings;
        this.selectedItem.led_warranty= warranty; 
        this.selectedItem.led_brand   = brand;
        this.selectedItem.led_vendors = vendoeListopt;
       
        


        //console.log("this.selectedItem.led_vendors:::",this.selectedItem.led_vendors);

      //this.$refs.message.selectionStart = 1;

      this.$root.$emit("bv::show::modal", "my-model", button);

      // console.log(this.$refs);
      // this.$refs.message[0].selectionEnd = 1;
    },
    modalSubmit(bvModalEvt) {
      var self = this;
      self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = "";
      if (self.selectedItem.id == 0) {
        submitUrl = self.insertUrl;
      } else {
        submitUrl = self.updateUrl;
      } 
      if(self.selectedItem.supervisor_id=='' || self.selectedItem.supervisor_id<0){
        self.$bvToast.toast('Please Select Supervisor!', {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
            return false;
      }
      //submitUrl = self.updateUrl;
     // self.selectedItem.message = this.selectedItem.new_message + "\n\n" + this.selectedItem.old_message;

      self.axios
        .post(submitUrl, {
          accesskey: self.$session.get("access_key"),
          data: self.selectedItem,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            self.$bvModal.hide("my-model");
            self.$bvToast.toast(response.data.message, {
              title: "Status",
              toaster: "b-toaster-bottom-right",
              autoHideDelay: 5000,
              variant: "warning",
              solid: true,
              appendToast: true,
            });
            self.initload();
          }
        })
        .catch(function(error) {
          alert(error);
        });
    },

    resetSelectedItem() {
      var self = this;
      self.selectedItem = Object.assign({}, self.emptyItem);
    },
    initload() {
      var self = this;
      
      if(self.datefrom!="" ||self.dateto!=""){
       
        self.timeData= '('+self.datefrom+' to '+self.dateto+')';
       
      }

      self.axios
        .post(self.recordUrl, {
          accesskey: self.$session.get("access_key"),
          ulb: self.$session.get("user_info").permissions.ulb_perm,
          role: self.$session.get('user_info').role,
          datefrom: self.datefrom,
          dateto: self.dateto,
        })
        .then(function(response) {
          if (response.data.error == 0 || response.data.error == "0") {
            //var filteredarr = self.filtercategory(response.data.result);
            //console.log("Complete Record:::", self.records);
            //console.log("Complete Record response.data.result:::", response.data.result);

            self.records    = response.data.result.complaints;
            self.loading    = false;
            self.totalRows  = self.records.length;
            self.led_brands = response.data.result.led_brands;
            var vendorList = response.data.result.led_vendors;
            

            // console.log("vendorList:::::",vendorList);
            


          

            /* ======= Push Light Wart Header ======= */
            self.$root.wattslight.forEach(function(date) {           
            //self.fields.push({ key: date, label: self.$moment(date).format("DD-MMM-YYYY"), class: "text-center", variant: "secondary" });
             self.fields.push({ key: 'w'+date, label: "W"+date, variant: "secondary", class: "text-center"});
              
            });
            self.fields.push({ key: "actions", label: "Actions", extra: 1, class: "text-right" });

            /* ======= Push Light Wart Data ======= */
            self.records.forEach(function(field){

              //field.w20 =50;
              var fettingData =JSON.parse(field.led_fittings);
              self.$root.wattslight.forEach(function(date) {  
                 var wt ='w'+date;    
                 var wval = fettingData[wt]>0?fettingData[wt]:0;
                 field[wt]=wval;
                //console.log('WDATA'+fettingData[wt]);
                //self.fields.push({ key: date, label: self.$moment(date).format("DD-MMM-YYYY"), class: "text-center", variant: "secondary" });
                // self.fields.push({ key: 'w'+date, label: "W"+date, variant: "secondary", class: "text-center"});                  
                });
            });


            
            

            /*const zoneOptions = arr.reduce((acc, current) => {
              const x = acc.find(item => item.value === current.value);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);*/
            self.zones = response.data.result.zones;
            self.wards_list = response.data.result.wards_list;
            self.zones.forEach(function(item) {
              //console.log(item.areacode + " " + self.$session.get("user_info").permissions.ulb_perm);
              if (String(item.areacode) === String(self.$session.get("user_info").permissions.ulb_perm)) {
                self.selectedItem.ulb = item.id;
              }
            });

            /* ********Brand List ***********  */
           self.brandOption=[];
         // self.wardfilterlist.push({'value':'all','text':'All Wards'});
          self.led_brands.forEach(function(row){
            var supLists ={'value':row.id,'text':row.brand_name};
            self.brandOption.push(supLists);
              
          });

          /* ********Vender List ***********  */
          self.vendorOption=[];
         // self.wardfilterlist.push({'value':'all','text':'All Wards'});
          vendorList.forEach(function(row){
            var supLists ={'value':row.id,'text':row.vendor_name};
            self.vendorOption.push(supLists);              
          });

          

          self.wardfilterlist=[];
          self.wardfilterlist.push({'value':'all','text':'All Wards'});
          self.wards_list.forEach(function(row){
            var supList ={'value':row.id,'text':row.areacode};
            self.wardfilterlist.push(supList);
              
          });



          }
          self.filteredrecords = self.networkChange(self.filterChange(self.records));
          // setTimeout(self.initload, 1000 * 30);
        })
        .catch(function(error) {
          console.log(error);
        });
        //alert('login '+self.email+" "+self.password);

        /*  ****** Supervisor list  ****** */
        self.supervisorfilterlist=[];
        self.supervisorfilterlist.push({'value':'all','text':'All Supervisor'});
        self.axios
          .post(self.supervisorUrl, {
            accesskey: self.$session.get("access_key")      
          })
          .then(function(response) {
            if (response.data.error == 0 || response.data.error == "0") {
              self.supervisorlist = response.data.result.supervisor;                 
              self.supervisorlist.forEach(function(row){
                var supList ={'value':row.supervisor_id,'text':row.username};
                self.supervisorfilterlist.push(supList);
                  
              });
                  
            }
          
          })
          .catch(function(error) {
            console.log(error);
          });




    },
    /*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    downloadcsv() {
      var self = this;
      var header = new Array();
     // header.push('Sr. no');
      self.fields.forEach(function(item) {
       // console.log('item.label:',item);
        if (!item.extra) {
          header.push(item.label);
        } else { 
          if(item.key == 'srno'){
            header.push(item.label);
          }
          if(item.key == "in_stock"){
            header.push(item.label);
          }
        }
      });

      //var d = table.rows().data();
      var finalarr = new Array();
      finalarr.push(header);
      var isr=1;
      self.filteredrecords.forEach(function(row) {
        var dataarr = new Array();
        
        self.fields.forEach(function(field) {
         // var rowValue ='';
        // console.log('field.key:',field.key);
          
          
          if (field.key != "extra") {
          console.log('rowrow::',row)
             var rowValue = row[field.key];

             if (field.key == "srno") {                    
                    rowValue =isr++;                
            } 
             if (field.key == "in_stock") {      
                    rowValue =row['no_of_fittings'] - row['no_of_fittings_used'];                
              } 
            if(field.key=='supervisor_id'){
              rowValue = self.supervisorlist.filter(function(item) {
                if (item.supervisor_id == rowValue) {
                  return item;
                }
              })[0].username;
            }

            if(field.key=='status'){
            rowValue = self.statusOptions.filter(function(item) {
              if (item.value == rowValue) {
                return item;
              }
            })[0].text;
            }

            //dataarr.push(row[field.key]);
            dataarr.push(rowValue);
            
          }
        });
        finalarr.push(dataarr);
      });

      let csvContent = "data:text/csv;charset=utf-8," + finalarr.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "led_driver_report.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    
    datefilter(){
      if(this.datefrom=='' || this.dateto==''){
        //this.timeData= this.datefrom+' to '+this.dateto;
        var mess = 'Please Select Date';
        this.$bvToast.toast(mess, {
              title: 'Status',
              toaster: 'b-toaster-bottom-right',
              autoHideDelay: 5000,
              variant: 'warning',
              solid: true,
              appendToast: true
            });
      }else{
        this.loading = true;
        this.initload() ;
      }
      
    }
  },
};
</script>
<style>
html {
  min-height: 100%;
}
body {
  background-image: url(../../assets/home-banner.png) !important;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-position: center center; */
  background-position: bottom;
}

.table {
  font-size: small;
}
.table .btn {
  font-size: 12px;
}
.table td,
.table th {
  vertical-align: middle;
}
#my-table-live .thead-dark th {
  color: #fff;
  background-color: #ff9a37;
  border-color: #ff9a37;
}
#my-table-live .first-col {
  border-radius: 20px 0px 0px 0px;
  min-width: 130px;
}
#my-table-live .last-cal {
  border-radius: 0px 20px 0px 0px;
  min-width: 153px;
}
.borderRadius20 {
  border-radius: 20px;
}
.table-responsive {
  border-radius: 20px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
.w-15{
	width: 15%;
}
.w-10{
	width: 10%;
}
.w-20{
	width: 20%;
}
.w-120{
	width: 25% !important;
}
.h-10{
	height: 10px !important;
}
.h-15{
	height: 15px !important;
}
.h-20{
	height: 20px !important;
}


.v-select{
    width:auto ;
    height: auto;
    padding-right: 0.75rem;
    background-image: none;
    padding: 0px;
    border: 0px;

}

.v-select-toggle {
    height: calc(1.5em + .5rem + 2px);
    padding-top: .25rem;
    padding-bottom: .25rem;
    padding-left: .5rem;
    font-size: .875rem !important;
}

.v-select .custom-select[multiple], .custom-select[size]:not([size="1"]) {
    height: auto;
    padding-right: .75rem;
    background-image: none;
    width: auto;
}
.customselectfilter button{
  height: 36px;
}

.tbl-header{
  background: #c6c6c6;
    padding: 6px;
    margin-bottom: 5px;
    text-align: center;
    font-weight: 700;
}

</style>
